import { useSelector          , 
         TypedUseSelectorHook }  from 'react-redux';

import { RootState            }  from './generalReducer';

export const useTypedSelector: TypedUseSelectorHook<RootState> = useSelector;
